import axios from "axios";

const devMode=process.env.REACT_APP_DEV_MODE;
console.log(devMode);

const api = axios.create({
    baseURL: devMode === "STAGING" ? 'https://dev-api.ocubuild.com/' 
                : devMode === "PRODUCTION" ? 'https://api.ocubuild.com' 
                : 'http://localhost:7071/'
});
console.log(api)

var functionKey = 'GFZrhB9U0Kn9ZtwIyFkupd2NSVlpFNNUhZW5nHNsbhP0AzFuwJuC1A=='; //staging
if (devMode === "PRODUCTION") {
    functionKey = "aKCFM45cBJI3BtflqLbQA4E2f8RMktLPebxeMPT37NgoAzFu3rFEWA=="; //production
}
console.log(api)

api.interceptors.request.use(config => {

    // add code parameter to all requests
    config.params = {
        ...config.params, // preserve existing params
        code: functionKey
    };

    return config;
}, error => {
    return Promise.reject(error);
});

export default api;